// amenities.js

import { baseURL } from 'utils/api'
import Dictionary from '../dictionary'
import axios from 'axios'

const { amenities } = Dictionary

const amenitiesServies = {
  view: async (paramsObj) => {
    return axios.get(baseURL + amenities.list(),{params: paramsObj})
  },
  add: async (data) => {
    return axios.post(baseURL + amenities.create(), data)
  },
  delete: async (id) => {
    return axios.delete(baseURL + amenities.delete(id))
  },
  edit: async (id, data) => {
    return axios.put(baseURL + amenities.update(id), data)
  },
  getDetailById: async (id) => {
    return axios.get(baseURL + amenities.getById(id))
  },
}
export default amenitiesServies